import Win10Card from "../Win10Card";

export default function OpdrachtInfoCard({
  werkbon,
  canReassignProject = false,
  onReassignProject,
  projectLinkSaving = false,
  projectOptions = [],
  selectedProjectId = "",
  onSelectProject,
  projectOptionsLoading = false,
}) {

  const field = (v) => v || "—";
  const opdrachtLabel =
    werkbon?.opdracht?.omschrijving ||
    werkbon?.omschrijving ||
    werkbon?.opdrachtNummer;
  const projectLabel =
    werkbon?.project?.naam ||
    werkbon?.project?.title ||
    werkbon?.projectNummer;
  const locatieLabel =
    werkbon?.locationText ||
    werkbon?.opdracht?.locatie ||
    werkbon?.locatie;
  const contactLabel = [
    werkbon?.contact?.name,
    werkbon?.contact?.role,
    werkbon?.contact?.phone,
    werkbon?.contact?.email,
  ]
    .filter(Boolean)
    .join(" • ");


  const statusKleur = (status) => {
    switch (status) {
      case "aangemaakt":
        return "text-gray-600";
      case "in_uitvoering":
        return "text-orange-600";
      case "afgerond":
        return "text-green-600";
      default:
        return "text-blue-600";
    }
  };


  return (
    <Win10Card title="Opdrachtinformatie">

      <div className="grid grid-cols-2 gap-3 text-sm">

        <div>
          <p className="font-semibold">Opdracht</p>
          <p>{field(opdrachtLabel)}</p>
        </div>

        <div>
          <div className="flex items-center justify-between gap-2">
            <p className="font-semibold">Project</p>
            {canReassignProject && typeof onReassignProject === "function" && (
              <button
                type="button"
                onClick={onReassignProject}
                disabled={projectLinkSaving || !selectedProjectId || projectOptionsLoading}
                className="rounded bg-indigo-600 px-2 py-1 text-xs text-white hover:bg-indigo-700 disabled:opacity-60"
              >
                {projectLinkSaving ? "Wijzigen..." : "Project wijzigen"}
              </button>
            )}
          </div>
          <p>{field(projectLabel)}</p>
          {canReassignProject && (
            <select
              value={selectedProjectId}
              onChange={(event) => onSelectProject?.(event.target.value)}
              disabled={projectOptionsLoading || projectLinkSaving}
              className="mt-2 w-full rounded border border-slate-300 bg-white px-2 py-1 text-xs"
            >
              <option value="">{projectOptionsLoading ? "Projecten laden..." : "-- kies project --"}</option>
              {projectOptions.map((project) => (
                <option key={project._id} value={project._id}>
                  {formatProjectOption(project)}
                </option>
              ))}
            </select>
          )}
        </div>

        <div>
          <p className="font-semibold">Locatie</p>
          <p>{field(locatieLabel)}</p>
        </div>

        <div>
          <p className="font-semibold">Contact</p>
          <p>{field(contactLabel || (werkbon?.contact?.unknown ? "Onbekend" : ""))}</p>
        </div>

        <div>
          <p className="font-semibold">Tijdmodus</p>
          <p>
            {werkbon.timeMode === "auto"
              ? "Automatisch (PL keurt goed)"
              : "Handmatig"}
          </p>
        </div>

        <div>
          <p className="font-semibold">Status</p>

          <p
            className={`font-medium ${statusKleur(werkbon.status)}`}
          >
            {field(werkbon.status)}
          </p>

        </div>

      </div>

    </Win10Card>
  );
}

function formatProjectOption(project) {
  const nummer = String(project?.projectNummer || project?.number || "").trim();
  const naam = String(project?.naam || project?.title || "").trim();
  if (nummer && naam) return `${nummer} - ${naam}`;
  return nummer || naam || "Project";
}
